<template>
    <div class="Bottom002870">
       <div class="auto">
        <div class="select-group">
          <dl v-for="(item,index) in MenuList" :key="item.text">
            <a-popover >
              <template #content trigger="hover">
                <div class="friendlyLinks">
                  <div  v-for="(items,indexs) in item.children" :key="items.text">
                    <a :href="items.url">{{items.text}}</a>
                  </div>
                </div>
                
              </template>
              <div class="btn_menu">
                <span style="flex: 0.5;"></span>
                <span>{{item.text}}</span>
                <span style="flex: 0.5;"></span>
                
              </div>
            </a-popover>
          </dl>

        </div>
        <div class="footer clearfix">
            <div class="share fr">
                <ul class="ul clearfix">
                    <!-- <li>
                            <img src="https://www.yzhospital.cn:8090/uploadfiles/2021/05/20210506152206014.png?5b6u5L+h5oiq5Zu+XzIwMjEwNTA2MTUxODQwLnBuZw==">
                            <aside>关注我们</aside>
                    </li> -->
                </ul>
            </div>
            <div class="copyright fl">
                版权所有 © 扬州市第三人民医院（江苏省苏北人民医院新区分院）
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                  苏ICP备14058637号-1
                </a>
                <br>
                <!-- <img src="https://www.yzhospital.cn/uploadfiles/2022/03/20220324141016733.png" style="margin-right: 0.3em;"> -->
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32100302010034" target="_blank">	
                  苏公网安备 32100302010035号
                </a>
                <a href="http://www.miitbeian.gov.cn/" target="_blank"></a>
                <br>
                地址：扬州市文昌西路延伸段（乘62路公交汽车可直达）<br>
                一站式电话：0514-87837171
                电子邮箱：jsyzsy003@163.com                
                <span>Designed by <a href="http://www.wanhu.com.cn" target="_blank">Wanhu</a>.</span>
            </div>
        </div>
       </div>
    </div>
</template>
<script>
  export default {
    name: 'footerHome',
    data () {
      return {
        MenuList:[
          {
            text:'国家卫健委友情链接',
            children:[
              {
                text:'国家卫健委',
                url:'http://www.akylx.cn/k/guojiaweijiweiguanwang/'
              }
            ]
          },
          {
            text:'江苏省卫健委友情链接',
            children:[
              {
                text:'江苏省卫健委',
                url:'http://wjw.jiangsu.gov.cn/'
              }
            ]
          },
          {
            text:'市卫健委友情链接',
            children:[
              {
                text:'扬州市卫健委',
                url:'http://wjw.yangzhou.gov.cn/'
              }
            ]
          },
          {
            text:'友情链接',
            children:[
              {
                text:'扬州第二人民医院（惠民医院）',
                url:'http://www.yzhmyy.com/'
              },
              {
                text:'扬州第一人民医院',
                url:'http://www.yangzhouyiyuan.com/'
              },
              {
                text:'苏北人民医院',
                url:'https://www.yzsbh.com/'
              }
            ]
          },

        ]
      }
    }
  }
</script>
<style lang="less" scoped >
  /deep/.ant-popover-arrow{
    display: none !important;
  }
  .clearfix:after {
      content: '';
      display: block;
      height: 0;
      clear: both;
  }
  .fr {
    float: right;
  }
  .Bottom002870{
    background: #6e818e;
    padding: 28px 0 44px 0;
    color: #fff;
    a{
      color: #fff;
    }
    .auto{
      max-width: 1280px;
      margin: 0 auto;
      padding: 0 2%;
    }
    .select-group{
      margin-bottom: 45px;
      text-align: left;
      >dl{
        background: rgba(255,255,255,0.11);
        border-radius: 2px;
        position: relative;
        z-index: 20;
        display: inline-block;
      }
      // >dl:not(:nth-child(4n)){margin-right: 2%;}
    }
    .share  {
      ul > * {
          float: left;
      }
      li{
        width: 91px;
        text-align: center;
        font-size: 15px;
        img {
            display: block;
            width: 100%;
        }
      }
       
    }
    .copyright {
      padding-left: 0;
      background: none;
      line-height: 32px;
      min-height: 72px;
      text-align: left;
      font-weight: 500;
      span{
        display: block;
        opacity: 0.4;
      }
    }
  }
  .btn_menu{
    padding: 0 28px 0 9px;
    text-align: center;
    background: url(https://www.yzhospital.cn/cn/images/Bottom002870_a_sel.png) no-repeat right 9px center;
    height: 45px;
    overflow: hidden;
    display: flex;
    align-items: center;
    >span:nth-child(2){
      padding: 0 4px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    >span:first-child,>span:last-child{
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      max-width: 62%;
      width: 30%;
      height: 4px;
      line-height: 4px;
      border-top: 1px dashed #fff;
    }
  }
  .btn_menu:hover{
    background: url(https://www.yzhospital.cn/cn/images/Bottom002870_a_sel_on.png) no-repeat right 9px center;
  }
  .friendlyLinks{
    border-bottom: 1px solid #6e818e;
    position: relative;
    bottom: -16px;
    >div{
      background: rgba(255,255,255,1);
      >a{
        line-height: 30px;
        color: #6e818e;
        padding:0 10px;
        position: relative;
        top: -9px;
      }
    }

  }
  @media(max-width:1280px){.auto_1280{ padding:0 2%;}}
  @media(max-width:768px){
    .Bottom002870 .select-group {
      margin-bottom: 10px;
    }
  }
      
@media(min-width: 641px){
  .Bottom002870{font-size: 16px;}
}
@media(min-width:1025px){
  .Bottom002870 .copyright{max-width: 760px; width: 60%;}
  .Bottom002870 .select-group dl{width:23.5%;}
  .Bottom002870 .select-group dl:not(:nth-child(4n)){margin-right: 2%;}
  .fr {
    float: right;
  }
}
@media(max-width:1024px){
  .Bottom002870 .share{display: table; margin: 0 auto;}
  .Bottom002870 .copyright{padding-left: 100px;}
  .Bottom002870 .select-group dl{margin-bottom: 2%;}
  .fl, .fr {
    float: none;
  }
}
@media(max-width:768px){
	.Bottom002870 .copyright{padding-left: 0;}
	.Bottom002870 .select-group dl{
    width: 49%;
    display: inline-block;
  }
  .Bottom002870 .select-group dl:not(:nth-child(2n)){
    margin-right: 2%;
  }
	.Bottom002870 .select-group{margin-bottom: 10px}
  .btn_menu{
    font-size: 12px;
    
  }
	// .Bottom002870 .select-group dt a{font-size: 12px;}
	// .Bottom002870 .select-group dd a{padding:5px;}
}
@media(min-width:768px) and (max-width:1024px){
  .Bottom002870 .select-group dl{ width: 32%}
  .Bottom002870 .select-group dl:not(:nth-child(3n)){margin-right: 2%;}
}
@media(max-width:260px){
  .Bottom002870 .select-group dl{ width: 100%}
}
</style>